import ShareByOrganizationStep from './ShareByOrganizationStep';

export default ShareByOrganizationStep;
